import React from 'react';
import styled from 'styled-components';
import Button from 'components/UI/Button';
import { RecommendationSection } from 'data/Product';
import { DISPLAY_MODE_LABELS, RECOMMENDATION_STRINGS } from 'constants/productRecommendations';
import { Border, Main, Text } from 'styles/themeColors';

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  border: 1px solid ${Border.main};
  border-radius: 8px;
  padding: 12px 20px;
  margin-bottom: 12px;
  background: ${Main.white};
`;

const Details = styled.div`
  flex: 1;
  min-width: 0;
`;

const Label = styled.p`
  margin: 0 0 4px;
  font-size: 12px;
  color: ${Text.placeholder};
`;

const Title = styled.p`
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: ${Text.primary};
`;

const Meta = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${Text.secondary};
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
`;

interface Props {
  // Position on the page; drives the element ids automation relies on.
  index: number;
  section: RecommendationSection;
  title: string;
  onEdit: () => void;
  onRemove: () => void;
  disabled?: boolean;
}

// The saved, collapsed form of a section (AC10/AC16); editing happens in RecommendationSectionEditor.
const RecommendationSectionCard = ({ index, section, title, onEdit, onRemove, disabled }: Props) => (
  <Card id={`recommendation-section-card-${index}`}>
    <Details>
      <Label>{RECOMMENDATION_STRINGS.CARD_LABEL}</Label>
      <Title>{title}</Title>
      <Meta>
        {RECOMMENDATION_STRINGS.PRODUCT_COUNT(section.items.length)} · {DISPLAY_MODE_LABELS[section.displayMode]}
      </Meta>
    </Details>
    {/* Orange outline on white. Not `isGhost`: that forces a transparent background and keeps
        the kit's default white text, so the label disappears. */}
    <Actions>
      <Button id={`recommendation-section-edit-${index}`} theme="brandDark" bgColor={Main.white} color={Main.brandDark} onClick={onEdit} disabled={disabled}>
        {RECOMMENDATION_STRINGS.EDIT}
      </Button>
      <Button id={`recommendation-section-remove-${index}`} theme="brandDark" bgColor={Main.white} color={Main.brandDark} onClick={onRemove} disabled={disabled}>
        {RECOMMENDATION_STRINGS.REMOVE}
      </Button>
    </Actions>
  </Card>
);

export default RecommendationSectionCard;
